import {
  ChartScatter,
  ChartSpline,
  FileText,
  History,
  House,
  Lightbulb,
  LayoutGrid,
  Search,
  Settings,
  SquareStack,
  TrendingUp,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  /** Path prefixes this item owns, the old pages it replaces included, so
   *  /tracking lights up 오늘 while it still lives at its old address. */
  match: string[]
  /** 0 = the morning's work, 1 = what is run, 2 = the setup behind it. */
  group: 0 | 1 | 2
  /** Shows the count of things to check (the attention items). */
  badge?: 'attention'
}

/** The sidebar, in order (plan 1-2). Eleven items in three groups. */
export const NAV: NavItem[] = [
  { to: '/', label: '오늘', icon: House, match: ['/', '/tracking'], group: 0, badge: 'attention' },
  { to: '/reports', label: '리포트', icon: FileText, match: ['/reports'], group: 0 },
  { to: '/insight', label: 'Insight', icon: Lightbulb, match: ['/insight'], group: 0 },
  { to: '/movement', label: '변동', icon: TrendingUp, match: ['/movement', '/analysis'], group: 0 },
  { to: '/research', label: '조사', icon: Search, match: ['/research'], group: 0 },
  { to: '/apps', label: '앱', icon: LayoutGrid, match: ['/apps'], group: 1 },
  { to: '/compare', label: '비교', icon: ChartScatter, match: ['/compare'], group: 1 },
  { to: '/analytics', label: '사용량', icon: ChartSpline, match: ['/analytics'], group: 1 },
  { to: '/playslots', label: 'Play 슬롯', icon: SquareStack, match: ['/playslots'], group: 1 },
  { to: '/jobs', label: '작업 기록', icon: History, match: ['/jobs'], group: 2 },
  { to: '/settings', label: '설정', icon: Settings, match: ['/settings'], group: 2 },
]

/** The phone's bottom tabs; everything else is under 더보기. */
export const TAB_PATHS = ['/', '/movement', '/apps', '/research']

function owns(prefix: string, pathname: string): boolean {
  if (prefix === '/') return pathname === '/'
  return pathname === prefix || pathname.startsWith(prefix + '/')
}

/** The path the menu lights up for: a detail opened from a page (the
 *  keyword drawer, a full page on a phone) belongs to that page, so a keyword
 *  opened from 변동 keeps 변동 lit; a detail reached by its address falls back
 *  to its own path. */
export function navPathname(loc: { pathname: string; state?: unknown }): string {
  const bg = (loc.state as { background?: { pathname?: unknown } } | null | undefined)?.background
  return bg && typeof bg.pathname === 'string' ? bg.pathname : loc.pathname
}

/** The item a path belongs to: the longest matching prefix wins. */
export function activeNav(pathname: string): NavItem | undefined {
  let best: NavItem | undefined
  let bestLen = -1
  for (const item of NAV) {
    for (const m of item.match) {
      if (owns(m, pathname) && m.length > bestLen) {
        best = item
        bestLen = m.length
      }
    }
  }
  return best
}
